import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import DataTable from "../Components/datatablepublisher";
import { RedirectNotLogin, AlertMessageOut, getSession, UpdateState, AlertMessage, clearSession, getState, RedirectNotContractor } from "../Components/function";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as axios from 'axios';
import $ from "jquery";
import { ApiEndpoint, limit_per_page, name, platform } from '../Constant';
import ReactPaginate from 'react-paginate';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class Summary extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      data: [],
      page: 1,
      total_page: 1,
      total_result: 0,
      offset: '-1',
      offset_set: 0,
      limit: limit_per_page,
      page_target: '0',
      specific_region: '',
      message: '',
    }

    this.clearPagingData = this.clearPagingData.bind(this);
    this.updatePageTarget = this.updatePageTarget.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectNotContractor();
      var that = this;
      this.loadDataFromServer();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectNotContractor();
    }

    componentWillReceiveProps(newProps){
      RedirectNotLogin();
      RedirectNotContractor();
    }

    AlertNoTableData = () => {
        return <div><div className='p15 center block'>There are no field of specialization at the moment, do check back later - No Result found!</div></div>;
      }

      clearPagingData = () => {
        UpdateState(this, 'page', 1);
        UpdateState(this, 'total_page', 1);
        UpdateState(this, 'total_result', 0);
        UpdateState(this, 'offset', '-1');
        UpdateState(this, 'offset_set', 0);
     }

     updatePageTarget(target){
       UpdateState(this, 'page_target', target);
     }

     updatePageRegionTarget(target){
       UpdateState(this, 'specific_region', target);
     }

      handlePageClick = (data) => {

        let selected = data.selected;
        let offset = Math.ceil((selected) * limit_per_page);
         UpdateState(this, 'offset', offset == 0 ? '-1' : offset);
         UpdateState(this, 'offset_set', offset);
         UpdateState(this, 'page', (selected + 1));
         let $specifit = getState(this, 'page_target') == '1' ? '1' : ''; 
        if($specifit != ""){
        this.loadDataFromServer();
        }
        else{
        this.loadDataFromServer();
        }
        };

    loadDataFromServer = async () => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: 'summary',
            user_id: getSession('userID'),
            limit: getState(this, 'limit'),
            offset: getState(this, 'offset'),
            page: getState(this, 'page'),
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');

            if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
      
          UpdateState(this, 'data', response.data.data.length > 0 ? response.data.data : []);
          UpdateState(this, 'total_page', response.data.total_page);
          UpdateState(this, 'total_result', response.data.total_result);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');
       
          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
            UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
            UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
        });
      }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    

    <div className="App iBG dash-dash-full">
    <div className="containers">
   
    <div className="card-lt-wrap ml0">
    <div className="card-lt breadcrumb">
  <h1><NavLink to="/dashboard">Dashboard</NavLink> <i className="fa fa-chevron-right"></i> <NavLink to="/editors">Editors</NavLink> <i className="fa fa-chevron-right"></i> {getSession('division')}</h1>
  </div>
  </div>

  <div className="card-lt-wrap ml0">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     {getState(this, 'data')?.length == 0 ? this.AlertNoTableData() : ''}
     {getState(this, 'data')?.map((summary, i) => {
        
   return(<>
      <NavLink to={"/publisher/"+summary['id']} key={i}>
      <div className="btn-lt tiny-lt">
      
        <div className="btn-text-lt">
        {summary['name']} 
        </div>
        <div style={{display: 'inline-block'}}>
        <span style={{fontSize: '20px'}}>[<b style={{color: 'red'}}>{summary['total']}</b>]</span>
        </div>
        </div>
        </NavLink>
        </>);
     })}
        
    
     </div>

     <div className="card-lt">  

<div>Page: {getState(this, 'page')} of {getState(this, 'total_page')} ⟺ ☆ Result: {parseInt(getState(this, 'offset_set')) + parseInt(1)} - {Math.ceil(getState(this, 'page') * limit_per_page) >= getState(this, 'total_result') ? getState(this, 'total_result') : Math.ceil(getState(this, 'page') * limit_per_page)} of {getState(this, 'total_result')}</div>

<ReactPaginate
          previousLabel={'« Prev'}
          nextLabel={'Next »'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={getState(this, 'total_page')}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
 </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Summary;